const state = {
  loginLinks: {
    // 아이디 찾기
    FIND_ID: 'https://info21.khu.ac.kr/com/SsoCtr/executeNiceId.do?flag=findId',
    // 비밀번호 찾기
    FIND_PASSWORD:
      'https://info21.khu.ac.kr/com/SsoCtr/executeNiceId.do?flag=findPswd',
    // FAQ
    INFO21_FAQ:
      'https://info21.zendesk.com/hc/ko/categories/6964356982927-%EC%9D%B8%ED%8F%AC21-FAQ',
  },
  ssoLoginLink: {
    // 운영
    INFO_URL: 'https://info21.khu.ac.kr/com/KsignCtr/loginProcCyberOne.do',
    // 개발
    // INFO_URL: 'http://dev.khu.ac.kr/com/KsignCtr/loginProcCyberOne.do'
    // 인포 → 관리자 웹 접속 테스트
    // INFO_URL: 'https://smart.khu.ac.kr/admin/login/info'
    // INFO_URL: 'http://192.168.173.2:9090/admin/login/info'
  },
  ssoLink: {
    // 알라딘 상담신청
    ALADDIN_COUNSEL:
      'https://aladdin.khu.ac.kr/portfolio/menu/redirect.do?url=/ptfol/cusl/unit/tot2/index.do',
    // 인포21 알림 설정
    ALARM_SETTING: 'https://portal.khu.ac.kr/',
    // 오늘의 강의(전자출결인증): 학생
    ATDC_STUDENT: 'https://portal.khu.ac.kr/haksa/clss/clss/elctCrtf/index.do',
    // 오늘의 강의(전자출결입력): 교원
    ATDC_PROFESSOR:
      'https://portal.khu.ac.kr/haksa/clssmngt/atend/elctAtend/index.do',
  },
  outLink: {
    // 싸이버원 경희대 카카오톡 오픈 채팅
    CYBERONE_CHAT: 'https://open.kakao.com/o/smRfTrzg',
    // 안드로이드 마켓 이동 링크
    ANDROID_APP:
      'https://play.google.com/store/apps/details?id=com.sports.piston',
    // ios 마켓 이동 링크
    IOS_APP: 'https://apps.apple.com/app/id6739140594',
    // 서울 캠퍼스맵
    SEOUL_MAP:
      'https://www.khu.ac.kr/kor/user/mapManager/view.do?menuNo=200356',
    // 국제 캠퍼스맵
    GLOBAL_MAP:
      'https://www.khu.ac.kr/kor/user/mapManager/view.do?menuNo=200357',
  },
  quickLink: {},
}

const getters = {
  getLoginLink: (state) => (key) => {
    return state.loginLinks[key]
  },
  getSsoLoginLink: (state) => (key) => {
    return state.ssoLoginLink[key]
  },
  getSsoLink: (state) => (key) => {
    return state.ssoLink[key]
  },
  getOutLink: (state) => (key) => {
    return state.outLink[key]
  },
}

export default {
  namespaced: true,
  state,
  getters,
}
